import { render, staticRenderFns } from "./FormProgramSpecializations.vue?vue&type=template&id=150bc48b&"
import script from "./FormProgramSpecializations.vue?vue&type=script&lang=js&"
export * from "./FormProgramSpecializations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports